<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Evento de Contingencia</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-select
              label="* Sucursal"
              v-model="evento.codigoSucursal"
              :items="sucursales"
              item-value="numero_sucursal"
              :loading="loadingsuc"
              dense
              outlined
              :readonly="frompuntoventa"
              color="green"
            ></v-select>
            <v-select
              label="* Punto de venta"
              v-model="evento.codigoPuntoVenta"
              :items="puntos"
              item-value="codigo_punto_venta"
              :loading="loadingpuntos"
              dense
              :readonly="frompuntoventa"
              color="green"
              outlined
            ></v-select>
            <v-select
              label="* Motivo Evento"
              v-model="evento.codigo"
              :items="motivos"
              item-value="codigo"
              :loading="loadingmot"
              dense
              outlined
            ></v-select>
            <v-text-field label="* Descripcion" v-model.trim="evento.descripcion" dense outlined></v-text-field>

            <v-row no-gutters>
              <v-col sm="6">
                <v-text-field
                  v-model="evento.fecha_inicio"
                  label="* Fecha Inicio"
                  type="date"
                  pattern="\d{4}-\d{2}-\d{2} \d{2}:\d{2}"
                  class="mr-2"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-text-field
                  v-model="hora_inicio"
                  label="* Hora inicio"
                  type="time"
                  pattern="\d{2}:\d{2}"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="6">
                <v-text-field
                  v-model="evento.fecha_fin"
                  label="* Fecha fin"
                  type="date"
                  pattern="\d{4}-\d{2}-\d{2}"
                  class="mr-2"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-text-field
                  v-model="hora_fin"
                  label="* Hora fin"
                  type="time"
                  pattern="\d{2}:\d{2}"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ evento.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingsuc: false,
        loadingmot: false,
        loadingpuntos: false,
        msg: '',
        puntos: [],
        motivos: [],
        sucursales: [],
        frompuntoventa: false,
        hora_inicio: null,
        hora_fin: null,
        evento: {
          id: null,
          codigo: 'string',
          codigoPuntoVenta: null,
          codigoSucursal: null,
          descripcion: 'string',
          fecha_inicio: null,
          fecha_fin: null,
        },
        apikeytoken: '',
      };
    },
    components: {},
    watch: {
      'evento.codigoSucursal': function() {
        //window.console.log(this.evento.codigoSucursal);
        if (this.evento.codigoSucursal != null) {
          this.getpuntosv(this.evento.codigoSucursal);
        }
      },
      'evento.codigo': function() {
        let m = this.motivos.find((x) => x.codigo == this.evento.codigo);
        //window.console.log('codigo: ', m);
        if (m) this.evento.descripcion = m.descripcion;
      },
    },
    methods: {
      async openmodal(item, puntoventa = null) {
        window.console.log(puntoventa);
        this.msg = '';
        await this.obtenerToknFactura();
        this.dialog = true;
        this.frompuntoventa = false;
        this.getmotivosevento();
        this.getsucursales();
        //this.getpuntosv();
        this.evento.id = null;
        this.evento.codigo = '';
        this.evento.codigoPuntoVenta = null;
        this.evento.codigoSucursal = null;
        this.evento.descripcion = '';
        this.evento.fecha_inicio = null;
        this.evento.fecha_fin = null;
        this.hora_inicio = null;
        this.hora_fin = null;
        if (puntoventa) {
          this.evento.codigoSucursal = puntoventa.codigoSucursal;
          this.evento.codigoPuntoVenta = puntoventa.codigoPuntoVenta;
          this.frompuntoventa = true;
          let idsucursal = this.$route.query.idsucursal;
          this.getpuntosv(idsucursal);
        }
        if (item) {
          this.evento.id = item.id;
          this.evento.codigo = item.codigo;
          this.evento.codigoPuntoVenta = item.codigoPuntoVenta;
          this.evento.codigoSucursal = item.codigoSucursal;
          this.evento.descripcion = item.descripcion;
          this.evento.fecha_inicio = item.fecha_inicio;
          this.evento.fecha_fin = item.fecha_fin;
        }
      },
      getsucursales() {
        let vue = this;
        this.loadingsuc = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.text = `(${x.ciudad}) ${x.direccion} [${x.numero_sucursal}]`;
            });
            vue.sucursales = response.data.data;
            vue.loadingsuc = false;
            window.console.log('getsucursales:', vue.sucursales);
          })
          .catch(function(error) {
            vue.loadingsuc = false;
            window.console.log(error);
          });
      },
      getpuntosv(idsucursal) {
        this.puntos = [];
        let vue = this;
        vue.loadingpuntos = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${idsucursal}`,
          headers: {
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('puntos:', data);
            data.map((x) => {
              x.text = `${x.nombre} (${x.descripcion})`;
            });
            vue.puntos = data;
            vue.loadingpuntos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingpuntos = false;
          });
      },
      getmotivosevento() {
        this.loadingmot = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/motivoevento`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data = data.filter((x) => {
              return x.codigo > 4;
            });
            // window.console.log('getmotivosevento', response.data);
            data.map((x) => {
              x.text = `(${x.codigo}) ${x.descripcion}`;
            });
            vue.motivos = data;
            vue.loadingmot = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingmot = false;
          });
      },
      save() {
        this.msg = '';
        if (!this.evento.codigo) this.msg = 'Seleccione el motivo.';
        //if (!this.evento.codigoPuntoVenta) this.msg = 'Seleccione un punto de venta.';
        //if (!this.evento.codigoSucursal) this.msg = 'Seleccione una sucursal.';
        if (!this.evento.descripcion) this.msg = 'Ingrese la descripcion.';
        if (!this.evento.fecha_inicio) this.msg = 'Ingrese la fecha de inicio.';
        if (!this.hora_inicio) this.msg = 'Ingrese la hora de inicio.';
        if (!this.hora_fin) this.msg = 'Ingrese la hora de fin.';
        if (!this.evento.fecha_fin) this.msg = 'Ingrese la fecha de fin.';
        if (this.msg) return;
        let evfecha = new Date(this.evento.fecha_inicio + `T${this.hora_inicio}:00.000`);
        let evfechafin = new Date(this.evento.fecha_fin + `T${this.hora_fin}:00.000`);
        if (evfecha.getTime() >= evfechafin.getTime()) {
          this.msg = 'La fecha de inicio debe ser mayor a la fecha de fin.';
        }
        if (this.msg) return;
        let eventocopy = window.Object.assign({}, this.evento);
        eventocopy.fecha_inicio += `T${this.hora_inicio}:00.000`;
        eventocopy.fecha_fin += `T${this.hora_fin}:00.000`;
        window.console.log(eventocopy);

        /* let a = 5;
        if (a > 1) return; */

        this.loading = true;
        let metodo = 'post';
        if (eventocopy.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
          data: eventocopy,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            if (data.id) {
              vue.msg = `Registrado, ID:${data.id}`;
              vue.$emit('newregevento', data);
            }
            window.console.log('eventonew::', data);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response.data);
            let data = error.response.data;
            vue.msg = `${data.mensaje}`;
            vue.loading = false;
          });
      },

      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        if(!idsuc) return;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
  };
</script>
